import './index.scss'
import chevronRight from 'url:@icon/chevron.right.plain.svg'

export type OptionsFormCard = {
  title: string,
  logo: {
    image: any,
    alt: string
  },
  description: string,
  enabled: boolean,
  onClick: () => void
}

export default function OptionsForm(props: {
  icon: {
    image: any,
    alt: string
  }
  title: string,
  description: string,
  cards: OptionsFormCard[],
  unavailableText: React.ReactNode
}) {
  const enabled = props.cards.filter(card => card.enabled);
  const disabled = props.cards.filter(card => !card.enabled);

  return <div className='chooser'>
    <div className='chooser-header'>
      <img src={props.icon.image} className='icon' alt={props.icon.alt} />

      <h1>{props.title}</h1>
      <p>{props.description}</p>
    </div>

    {
      enabled.length > 0 ? <div className='card'>
        {enabled.map((card, idx) => {
          return <div key={card.title}>
            {idx !== 0 ? <div className='divider' /> : null}
            <CreateOption onClick={card.onClick}
              logo={card.logo}
              title={card.title}
              description={card.description} />
          </div>
        })}
      </div> : null
    }

    {
      disabled.length > 0 ? <>
        <h3 style={{ marginBottom: '0' }}>Unavailable</h3>

        {disabled.map((card) => {
          return <div className='card unavailable' key={card.title}>
            <CreateOption
              onClick={null}
              logo={card.logo}
              title={card.title}
              description={card.description} />
          </div>
        })}

        <p style={{ margin: '0' }}>{props.unavailableText}</p>
      </> : null
    }
  </div>
}

function CreateOption(props: {
  onClick: (() => void) | null,
  logo: {
    image: any,
    alt: string
  },
  title: string,
  description: string
}) {
  return <div className={'option-row'}>
    <div className='option' onClick={() => {
      props.onClick && props.onClick();
    }}>
      <img src={props.logo.image} className='provider-logo' alt={props.logo.alt} />
      <div className='option-text'>
        <h4>{props.title}</h4>
        <p>{props.description}</p>
      </div>
      <img src={chevronRight} className='chevron' alt='' />
    </div>
  </div>
}